import { z } from "zod/v4";

export const TemplateOnboardingConfigSchema = z.object({
	prompts: z.array(z.string()).default([]),
	description: z.string().optional(),
});
export type TemplateOnboardingConfig = z.infer<typeof TemplateOnboardingConfigSchema>;
